import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'vc-footer-disclaimer',
  templateUrl: './footer-disclaimer.component.html',
  styleUrls: ['./footer-disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterDisclaimerComponent {
  constructor() {}
}
